"use client";

import { c as _c } from "react/compiler-runtime";
import { graphql, readFragment, useQuery, useSubscription } from "@opensea/graphql";
import { useEffect, useMemo, useState } from "react";
import { useAddress } from "../../polychain/hooks";
import { ContextBalanceFragment } from "./ContextBalance.fragment";
import { BalancesContext } from "./context";
const query = graphql(`
    query BalancesQuery(
      $address: Address!
      $disableSpamFiltering: Boolean = false
    ) {
      addressBalances(
        address: $address
        disableSpamFiltering: $disableSpamFiltering
      ) {
        ...ContextBalance
      }
    }
  `, [ContextBalanceFragment]);
const queryContext = {
  suspense: false
};
const subscriptionQuery = graphql(`
    subscription BalancesSubscription(
      $address: Address!
      $filter: CurrenciesFilter
    ) {
      currencyOwnershipUpdates(address: $address, filter: $filter) {
        id
        ...ContextBalance
      }
    }
  `, [ContextBalanceFragment]);
export function BalancesProvider(t0) {
  const $ = _c(28);
  const {
    initialBalances,
    disableSpamFiltering: t1,
    children
  } = t0;
  const disableSpamFiltering = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== initialBalances) {
    t2 = initialBalances ?? [];
    $[0] = initialBalances;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const [balances, setBalances] = useState(t2);
  const [loading, setLoading] = useState(initialBalances === undefined);
  const address = useAddress();
  const t3 = initialBalances !== undefined || address === undefined;
  const t4 = address ?? "";
  let t5;
  if ($[2] !== disableSpamFiltering || $[3] !== t4) {
    t5 = {
      address: t4,
      disableSpamFiltering
    };
    $[2] = disableSpamFiltering;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t3 || $[6] !== t5) {
    t6 = {
      query,
      pause: t3,
      context: queryContext,
      variables: t5
    };
    $[5] = t3;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      throwOnError: false
    };
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const [t8, reexecuteQuery] = useQuery(t6, t7);
  const {
    data
  } = t8;
  let t10;
  let t9;
  if ($[9] !== data) {
    t9 = function setFetchedBalances() {
      if (data) {
        setBalances(data.addressBalances.map(_temp));
        setLoading(false);
      }
    };
    t10 = [data];
    $[9] = data;
    $[10] = t10;
    $[11] = t9;
  } else {
    t10 = $[10];
    t9 = $[11];
  }
  useEffect(t9, t10);
  const t11 = address === undefined;
  const t12 = address ?? "";
  let t13;
  if ($[12] !== disableSpamFiltering) {
    t13 = disableSpamFiltering ? {
      disableSpamFiltering
    } : undefined;
    $[12] = disableSpamFiltering;
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  let t14;
  if ($[14] !== t12 || $[15] !== t13) {
    t14 = {
      address: t12,
      filter: t13
    };
    $[14] = t12;
    $[15] = t13;
    $[16] = t14;
  } else {
    t14 = $[16];
  }
  let t15;
  if ($[17] !== t11 || $[18] !== t14) {
    t15 = {
      query: subscriptionQuery,
      pause: t11,
      variables: t14
    };
    $[17] = t11;
    $[18] = t14;
    $[19] = t15;
  } else {
    t15 = $[19];
  }
  let t16;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = {
      onResult: newData => {
        setBalances(prev => {
          const newBalance = readFragment(ContextBalanceFragment, newData.currencyOwnershipUpdates);
          if (newBalance.quantity === "0") {
            return prev.filter(balance => balance.id !== newData.currencyOwnershipUpdates.id).sort(_temp2);
          }
          if (prev.find(balance_1 => balance_1.id === newData.currencyOwnershipUpdates.id)) {
            return prev.map(balance_0 => {
              if (balance_0.id === newData.currencyOwnershipUpdates.id) {
                return newBalance;
              }
              return balance_0;
            }).sort(_temp3);
          }
          return [...prev, newBalance].sort(_temp4);
        });
      }
    };
    $[20] = t16;
  } else {
    t16 = $[20];
  }
  useSubscription(t15, t16);
  let t17;
  let t18;
  if ($[21] !== balances || $[22] !== loading || $[23] !== reexecuteQuery) {
    t18 = {
      balances,
      loading,
      refreshBalances: reexecuteQuery
    };
    $[21] = balances;
    $[22] = loading;
    $[23] = reexecuteQuery;
    $[24] = t18;
  } else {
    t18 = $[24];
  }
  t17 = t18;
  const value = t17;
  let t19;
  if ($[25] !== children || $[26] !== value) {
    t19 = <BalancesContext.Provider value={value}>{children}</BalancesContext.Provider>;
    $[25] = children;
    $[26] = value;
    $[27] = t19;
  } else {
    t19 = $[27];
  }
  return t19;
}
function _temp4(a_1, b_1) {
  return Number(b_1.usdValue) - Number(a_1.usdValue);
}
function _temp3(a_0, b_0) {
  return Number(b_0.usdValue) - Number(a_0.usdValue);
}
function _temp2(a, b) {
  return Number(b.usdValue) - Number(a.usdValue);
}
function _temp(ab) {
  return readFragment(ContextBalanceFragment, ab);
}